module.exports = __webpack_public_path__ + "static/media/level-up-ribbon.3ceab7b2.png";